import React from 'react';
import axios from "../../containers/api";
import {showCatchError} from "../../helpers/Utils";
import { Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, Badge, ModalFooter } from "reactstrap";
import { Table } from "../../components/table/Table";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
 
import AnswerComment from "./AnswerComment";
 
class AdminManageComment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            CommentLists: [],
            errors: [],
            AnswerModal: false, 
            ShowAnswerModal: false, 
            OneComment: {},
            
            CommentId: null, 
            optionsMenu: null,
            AnswerList: [],
            AnswerMsg: ""
        }
        console.log(this.props)
    }

    componentDidMount() {
         
       // this.CheckMemberTypeIsAdmin();
       this.GetAllComment();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    this.GetAllComment();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    GetAllComment = () => {
        this.props.showSpinner();
        axios.get('api/v1/Comment/GetAllQuestion')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) 
                        this.setState({CommentLists: res.data.data});
                else
                this.setState({ alertText: res.data.errors, loginAlert: true, loading: false });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
   
    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget, optionsMenu: id });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null, optionsMenu: null });
    };
    openModal = (modalName,item) => {
      
           
        this.setState({[modalName]: true});
    }
    closeModal = (modalName) => {
        this.setState({ [modalName]: false });

        //if (modalName ==="AnswerModal")
        //    this.GetAllComment();
        
    };
    GetAllAnswer = (TransportationCompanyId, DriverId, ParentId) => {
        this.props.showSpinner();
        /*  axios.get('/api/v1/Comment/GetAllAnswer?ParentId=' + ParentId + '&TransportationCompanyId=' + TransportationCompanyId + '&DriverId=' + DriverId) */
         let model = {
            Item1: TransportationCompanyId,
            Item2: DriverId,
            Item3: ParentId,

        }

        axios.post('/api/v1/Comment/GetAllAnswer', model) 
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    if (res.data.data.length != null && res.data.data.length > 0) {
                        this.setState({ AnswerList: res.data.data, AnswerMsg: "" });
                        //console.log(res.data.data);
                    } else {
                        this.setState({ AnswerList: [], AnswerMsg: "درخواستی وجود ندارد" });
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3> رسیدگی به شکایات</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                 
                                <Table
                                    tableHeaders={[
                                        "عنوان",
                                        "متن پبام",
                                        "نام",
                                        "نوع",
                                        "تاريخ پبام",
                                        "ساعت پيام",
                                        "کد رهگیری",
                                        "پاسخ",
                                        "نمایش پاسخ",
                                    ]}

                                    tableRow={this.state.CommentLists}

                                    tableData={[
                                        item => {
                                            return item.title
                                        },
                                        item => {
                                            return item.desc
                                        },
                                        item => {
                                                if(item.type===0)
                                                    return item.transportationCompanyId !== null ? item.transportationCompanyFullName : item.driverFullName;
                                                else
                                                    return item.name
                                        },
                                        item => {
                                            if(item.type===0)
                                                return item.transportationCompanyId !== null ? "صاحب كالا" : "راننده";
                                            else
                                                return "کاربر سایت";
                                        },
                                        item => {
                                            return item.date;
                                        },
                                        item => {
                                            return item.time;
                                        },
                                        item => {
                                            return item.trackingCode;
                                        },
                                        item => {
                                           return (
                                                    <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                   onClick={() => this.setState({ AnswerModal: true, CommentId: item.commentId  })}>
                                                  پاسخ
                                                    </Button>


                                                )
                                            

                                        },
                                         item => {
                                           return (
                                                   
                                                 <Button outline color="primary" size="sm"
                                                   onClick={() => this.setState({ ShowAnswerModal: true }, () => this.GetAllAnswer(item.transportationCompanyId, item.driverId, item.commentId)
                                                                    )}>
                                                   نمایش پاسخ
                                                                </Button>

                                                )
                                            

                                        },

                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.AnswerModal} size="xlg" toggle={() => this.closeModal("AnswerModal")}>
                    <ModalHeader toggle={() => this.closeModal("AnswerModal")}>
                       پاسخ
                    </ModalHeader>
                    <ModalBody>
                        <AnswerComment
                            isModal={true}
                            
                            CommentId={this.state.CommentId}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ShowAnswerModal} size="xlg" toggle={() => this.closeModal("ShowAnswerModal")}>
                    <ModalHeader toggle={() => this.closeModal("ShowAnswerModal")}>
                       پاسخ
                    </ModalHeader>
                    <ModalBody>
                        <Table
                            tableHeaders={[
                                "عنوان",
                                "متن پبام",
                                "تاريخ پبام",
                                "ساعت پيام",
                                "کد رهگیری",
                                

                            ]}

                            tableRow={this.state.AnswerList}

                            tableData={[
                                item => {
                                    return item.title
                                },
                                item => {
                                    return item.desc
                                },
                                item => {
                                    return item.date;
                                },
                                item => {
                                    return item.time;
                                },
                                item => {
                                    return item.trackingCode;
                                },
                            ]} />
                    </ModalBody>
                </Modal>

                 

                 

                  

                 

                

                
                 
            </>
        );
    }
}

export default AdminManageComment;